export const github_actionTypes = {
    GET_TILES_DATA: "GET_TILES_DATA",
    TILES_DATA: "TILES_DATA",

}
